import styled from 'styled-components'

export const ExploreTwoRowsTextCell = (props: {
  firstRow: React.ReactNode
  secondRow: React.ReactNode
  gap?: number
}) => (
  <Root $gap={props.gap ?? 0}>
    <div>{props.firstRow}</div>
    <div>{props.secondRow}</div>
  </Root>
)

const Root = styled.div<{ $gap: number }>`
  color: var(--text-11);
  gap: ${({ $gap }) => $gap}px;

  display: grid;
  grid-template-rows: auto auto;

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
